import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import {axios} from '@/api/axios';
import {httpErrorHandler} from '@/api/http-error-handler';
import '@mdi/font/css/materialdesignicons.css'
import Vuelidate from 'vuelidate';

axios.interceptors.response.use(response => response, error => httpErrorHandler(error));

axios.interceptors.request.use(
  response => {
    response.headers = {...response.headers, 'Authorization': `Bearer ${localStorage.getItem('jwt')}`};
    return response;
  },
  error => Promise.reject(error)
);

Vue.config.productionTip = false;
Vue.use(Vuelidate as any);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
